<template>
  <div class="bg-white rounded-[12px] border border-gray-100">
    <div class="p-6 pb-4 border-b border-gray-100 shadow-[0_1px_4px_#CACACA29]">
      <div class="flex flex-row items-center gap-2">
        <span class="material-symbols-outlined text-[24px] text-gray-600">
          {{ icon }}
        </span>
        <h3 class="text-lg leading-6 font-semibold text-primary mb-0">
          {{ title }}
        </h3>
      </div>
      <div class="text-sm leading-[18px] text-gray-600 mt-2">
        {{ description }}
      </div>
    </div>
    <div class="px-6 py-5 flex flex-col gap-4">
      <slot />
      <template v-if="$slots.result">
        <div class="h-px bg-gray-200 shrink-0 mt-1" />
        <slot name="result" />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DirectChatBlock',
  props: {
    icon: { type: String, default: '' },
    title: { type: String, default: '' },
    description: { type: String, default: '' },
  },
};
</script>
